/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type GetWalletsByAssetResponseType = typeof GetWalletsByAssetResponseType[keyof typeof GetWalletsByAssetResponseType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetWalletsByAssetResponseType = {
  currency: 'currency',
  commodity: 'commodity',
  crypto: 'crypto',
  securities: 'securities',
  fund: 'fund',
  debenture: 'debenture',
  insurance: 'insurance',
  alternative: 'alternative',
  credit: 'credit',
  earn: 'earn',
  digital_exchange: 'digital_exchange',
  bond: 'bond',
} as const;
